module.exports = {
  wth: require('./with'),
  select: require('./select'),
  from: require('./from'),
  where: require('./where'),
  group: require('./group'),
  having: require('./having'),
  setop: require('./setop'),
  order: require('./order'),
  limit: require('./limit'),
  offset: require('./offset'),
  del: require('./delete'),
  returning: require('./returning'),
  insert: require('./insert'),
  update: require('./update'),
  set: require('./set')
}
